export default __webpack_public_path__ + "static/media/kahsh-foundation-bg-mobile.66d04729.png";